import {
  getCurrentEnvironment,
  getCurrentEnvironmentEndpoint,
} from "@/src/constants/environmentConstants.js";
import imagePath from "@/src/paths/imagePath.js";
import WorkspaceService from "@/src/api/WorkspaceService.js";
import { imageNames } from "@/src/constants/imageConstants.js";

export const inboxNotificationSound =
  "https://s3.amazonaws.com/contlo.in/new_message_left_panel.mp3";

export const addAsLeadText = "Unknown User";

export const chatEntityType = {
  USER: "user",
  HUMAN_AGENT: "human",
  AI_AGENT: "llm",
};

export const chatEntityGroups = {
  USER: "user",
  AGENT: "agent",
};

export const conversationStatuses = {
  OPEN: "Open",
  CLOSED: "Closed",
  REOPENED: "Reopened",
};

export const inboxTabs = [
  { id: conversationStatuses.OPEN, title: "Open" },
  { id: conversationStatuses.CLOSED, title: "Closed" },
];

export const agentDetailsTabKeys = {
  DETAILS: "details",
  ASSOCIATIONS: "associations",
};

export const agentDetailsTabs = [
  { id: agentDetailsTabKeys.DETAILS, title: "Details" },
  { id: agentDetailsTabKeys.ASSOCIATIONS, title: "Associations" },
];

export const inboxPriorityOptions = [
  { value: null, text: "All" },
  { value: true, text: "Priority" },
  { value: false, text: "Not priority" },
];

export const conversationStatusMapping = {
  [conversationStatuses.OPEN]: {
    text: "Close",
    past: "Closed",
    loading: "Closing..",
    selected: imageNames.CLOSE_CHAT_SELECTED_ICON,
    unselected: imageNames.CLOSE_CHAT_UNSELECTED_ICON,
    value: conversationStatuses.CLOSED,
  },
  [conversationStatuses.CLOSED]: {
    text: "Re-open",
    past: "Re-opened",
    loading: "Re-opening..",
    selected: imageNames.OPEN_CHAT_SELECTED_ICON,
    unselected: imageNames.OPEN_CHAT_UNSELECTED_ICON,
    value: conversationStatuses.REOPENED,
  },
  [conversationStatuses.REOPENED]: {
    text: "Close",
    past: "Closed",
    loading: "Closing..",
    selected: imageNames.CLOSE_CHAT_SELECTED_ICON,
    unselected: imageNames.CLOSE_CHAT_UNSELECTED_ICON,
    value: conversationStatuses.CLOSED,
  },
};

export const inboxStarConfig = {
  text: {
    true: "Remove priority",
    false: "Mark as priority",
  },
};

export const inboxUserExtraItems = [
  {
    id: -1,
    name: "Unassigned",
    profile_pic: imagePath.neutral.common.unassignedProfile,
  },
  {
    id: -555,
    name: "AI Agent",
    profile_pic: imagePath.neutral.platform.superAGILogoRound,
  },
];

export const generateEmbedScript = (workspaceId = "") => {
  const currentEnv = getCurrentEnvironment();
  const currentEndpoint = getCurrentEnvironmentEndpoint();
  const finalWorkspaceId =
    workspaceId || WorkspaceService.getCurrentWorkspaceId();
  const userId = localStorage.getItem("userId");

  const config = {
    w: parseInt(finalWorkspaceId),
    e: currentEnv,
    ...(userId && { u: parseInt(userId) }),
  };

  const encrypted = btoa(JSON.stringify(config));

  return `<script src="${currentEndpoint}/js/livechat/dist/livechat.iife.js" data-config="${encrypted}"></script>`;
};

export const attachmentActionConfig = {
  download: {
    id: "download",
    text: "Download",
    selected: "DOWNLOAD_GREY",
    unselected: "DOWNLOAD_GREY",
    size: 16,
    tooltip: true,
  },
  delete: {
    id: "delete",
    text: "Delete",
    icon: "DELETE_GREY",
    size: 16,
  },
};

export const inputModes = [
  {
    value: "email",
    label: "Email",
    icon: "EMAIL_GREY",
  },
  {
    value: "livechat",
    label: "Live Chat",
    icon: "OPEN_CHAT_SELECTED_ICON",
  },
];

export const emailDirections = {
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
};

export const replyTypes = {
  REPLY: false,
  REPLY_ALL: true,
};